/**
 * @generated SignedSource<<d66339b8e5815835c94600b317e89593>>
 * @relayHash 8d72bfa055c6fdfde707669ce5104bc0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0376bc7752cbb270206d5bcd51b533ec3fa2f679207bdd786d4dab220eace86f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "UNKNOWN" | "%future added value";
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum = "CLOSED" | "IGNORED" | "OPEN" | "UNKNOWN" | "%future added value";
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum = "DAST" | "SAST" | "SCA" | "UNKNOWN" | "%future added value";
export type GraphQueryMetadataSortEnum = "ASC" | "DESC" | "%future added value";
export type GraphQueryMetadataProjectAssociatedVulnerabilityInput = {
  and?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputAnd> | null;
  or?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputOr> | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputAnd = {
  createdAt?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt | null;
  lastUpdated?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated | null;
  or?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputOrInner> | null;
  to_container?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer | null;
  to_severity?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity | null;
  to_status?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus | null;
  to_type?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToType | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt = {
  range?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtRangeField | null;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtMetadataSortField | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtRangeField = {
  gt?: AGG$DateTime | null;
  gte?: AGG$DateTime | null;
  lt?: AGG$DateTime | null;
  lte?: AGG$DateTime | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAtMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null;
  priority?: number | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated = {
  range?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedRangeField | null;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedMetadataSortField | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedRangeField = {
  gt?: AGG$DateTime | null;
  gte?: AGG$DateTime | null;
  lt?: AGG$DateTime | null;
  lte?: AGG$DateTime | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdatedMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null;
  priority?: number | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputOrInner = {
  createdAt?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt | null;
  lastUpdated?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated | null;
  to_container?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer | null;
  to_severity?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity | null;
  to_status?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus | null;
  to_type?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToType | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer = {
  containerAri?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAri | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAri = {
  value?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValue | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValue = {
  notValues?: ReadonlyArray<string> | null;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValueMetadataSortField | null;
  values?: ReadonlyArray<string> | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainerAriValueMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null;
  priority?: number | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity = {
  notValues?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum> | null;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverityMetadataSortField | null;
  values?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum> | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverityMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null;
  priority?: number | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus = {
  notValues?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum> | null;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatusMetadataSortField | null;
  values?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum> | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatusMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null;
  priority?: number | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToType = {
  notValues?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum> | null;
  sort?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToTypeMetadataSortField | null;
  values?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum> | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputToTypeMetadataSortField = {
  order?: GraphQueryMetadataSortEnum | null;
  priority?: number | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputOr = {
  and?: ReadonlyArray<GraphQueryMetadataProjectAssociatedVulnerabilityInputAndInner> | null;
  createdAt?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt | null;
  lastUpdated?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated | null;
  to_container?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer | null;
  to_severity?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity | null;
  to_status?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus | null;
  to_type?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToType | null;
};
export type GraphQueryMetadataProjectAssociatedVulnerabilityInputAndInner = {
  createdAt?: GraphQueryMetadataProjectAssociatedVulnerabilityInputCreatedAt | null;
  lastUpdated?: GraphQueryMetadataProjectAssociatedVulnerabilityInputLastUpdated | null;
  to_container?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToContainer | null;
  to_severity?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToSeverity | null;
  to_status?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToStatus | null;
  to_type?: GraphQueryMetadataProjectAssociatedVulnerabilityInputToType | null;
};
export type SecurityPageRootQuery$variables = {
  cloudAri: string;
  cloudId: string;
  filter?: GraphQueryMetadataProjectAssociatedVulnerabilityInput | null;
  getContainers: boolean;
  numberOfContainersToFetch: number;
  numberOfVulnsToFetch: number;
  projectKey: string;
};
export type SecurityPageRootQuery$data = {
  readonly devOps: {
    readonly providers: {
      readonly securityProviders: ReadonlyArray<{
        readonly appInstallationId: string | null;
        readonly id: string;
        readonly linkedWorkspaces: {
          readonly nodes: ReadonlyArray<{
            readonly __typename: "AriGraphRelationship";
          } | null> | null;
        } | null;
        readonly logoUrl: AGG$URL | null;
        readonly name: string | null;
      } | null> | null;
    } | null;
  } | null;
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly linkedSecurityContainers: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly to: {
              readonly data?: {
                readonly providerId?: string | null;
              } | null;
            };
          };
        } | null> | null;
      };
      readonly linkedVulnsForAnalytics: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly vulnerability?: {
              readonly securityContainer: {
                readonly providerId: string | null;
              } | null;
            } | null;
          };
        } | null>;
      } | null;
      readonly totalLinkedSecurityContainerCount: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"MainPage">;
    };
  } | null;
};
export type SecurityPageRootQuery = {
  response: SecurityPageRootQuery$data;
  variables: SecurityPageRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "getContainers"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfContainersToFetch"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfVulnsToFetch"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v8 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v9 = {
  "kind": "ScalarField",
  "name": "totalLinkedSecurityContainerCount"
},
v10 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "numberOfContainersToFetch"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "providerId"
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "ThirdPartySecurityContainer"
},
v14 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v15 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "numberOfVulnsToFetch"
},
v16 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "and": {
        "lastUpdated": {
          "sort": {
            "order": "ASC",
            "priority": 1
          }
        }
      }
    }
  },
  (v15/*: any*/)
],
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "ScalarField",
  "name": "name"
},
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "concreteType": "DevOps",
  "kind": "LinkedField",
  "name": "devOps",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "cloudAri"
        },
        {
          "kind": "Literal",
          "name": "providerTypes",
          "value": [
            "SECURITY"
          ]
        }
      ],
      "concreteType": "DevOpsProviders",
      "kind": "LinkedField",
      "name": "providers",
      "plural": false,
      "selections": [
        {
          "concreteType": "DevOpsSecurityProvider",
          "kind": "LinkedField",
          "name": "securityProviders",
          "plural": true,
          "selections": [
            (v17/*: any*/),
            {
              "kind": "ScalarField",
              "name": "appInstallationId"
            },
            {
              "kind": "ScalarField",
              "name": "logoUrl"
            },
            (v18/*: any*/),
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 100
                }
              ],
              "concreteType": "AriGraphRelationshipConnection",
              "kind": "LinkedField",
              "name": "linkedWorkspaces",
              "plural": false,
              "selections": [
                {
                  "concreteType": "AriGraphRelationship",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v19/*: any*/)
                  ]
                }
              ],
              "storageKey": "linkedWorkspaces(first:100)"
            }
          ]
        }
      ]
    }
  ]
},
v21 = [
  (v17/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v23 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "DevOpsFeatureFlag"
},
v24 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "DevOpsOperationsComponentDetails"
},
v25 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "DevOpsOperationsIncidentDetails"
},
v26 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "DevOpsOperationsPostIncidentReviewDetails"
},
v27 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "DevOpsPullRequestDetails"
},
v28 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "DevOpsRepository"
},
v29 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "DevOpsSecurityVulnerabilityDetails"
},
v30 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "JiraAutodevJob"
},
v31 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "JiraConfluenceRemoteIssueLink"
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "JiraCustomRemoteIssueLink"
},
v33 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "JiraIssueRemoteIssueLink"
},
v34 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "JiraWebRemoteIssueLink"
},
v35 = [
  (v8/*: any*/),
  (v15/*: any*/)
],
v36 = {
  "kind": "ScalarField",
  "name": "url"
},
v37 = {
  "kind": "ScalarField",
  "name": "key"
},
v38 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v39 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SecurityPageRootQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v7/*: any*/),
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "jiraProjectByKey",
              "plural": false,
              "selections": [
                {
                  "args": [
                    (v8/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "getContainers",
                      "variableName": "getContainers"
                    },
                    {
                      "kind": "Variable",
                      "name": "numberOfContainersToFetch",
                      "variableName": "numberOfContainersToFetch"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "MainPage"
                },
                (v9/*: any*/),
                {
                  "kind": "RequiredField",
                  "field": {
                    "args": (v10/*: any*/),
                    "concreteType": "AriGraphRelationshipConnection",
                    "kind": "LinkedField",
                    "name": "linkedSecurityContainers",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationshipEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationship",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AriGraphRelationshipNode",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": [
                                  {
                                    "condition": "getContainers",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v14/*: any*/)
                    ]
                  },
                  "action": "THROW"
                },
                {
                  "alias": "linkedVulnsForAnalytics",
                  "args": (v16/*: any*/),
                  "concreteType": "GraphJiraVulnerabilityConnection",
                  "kind": "LinkedField",
                  "name": "linkedSecurityVulnerabilitiesByProject",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "GraphJiraVulnerabilityEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "GraphJiraVulnerability",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "condition": "getContainers",
                              "kind": "Condition",
                              "passingValue": true,
                              "selections": [
                                {
                                  "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                  "kind": "LinkedField",
                                  "name": "vulnerability",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "concreteType": "ThirdPartySecurityContainer",
                                      "kind": "LinkedField",
                                      "name": "securityContainer",
                                      "plural": false,
                                      "selections": (v12/*: any*/)
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "action": "THROW"
          }
        ]
      },
      (v20/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "SecurityPageRootQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v17/*: any*/),
              {
                "args": (v10/*: any*/),
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "linkedSecurityContainers",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "condition": "getContainers",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v13/*: any*/),
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v17/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "args": [
                  (v8/*: any*/)
                ],
                "kind": "ScalarField",
                "name": "totalLinkedSecurityVulnerabilityCount"
              },
              {
                "args": (v35/*: any*/),
                "concreteType": "GraphJiraVulnerabilityConnection",
                "kind": "LinkedField",
                "name": "linkedSecurityVulnerabilitiesByProject",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphJiraVulnerabilityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GraphJiraVulnerability",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                            "kind": "LinkedField",
                            "name": "vulnerability",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "condition": "getContainers",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "concreteType": "ThirdPartySecurityContainer",
                                    "kind": "LinkedField",
                                    "name": "securityContainer",
                                    "plural": false,
                                    "selections": [
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v36/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                "kind": "LinkedField",
                                "name": "identifiers",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                  },
                                  (v36/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                "kind": "LinkedField",
                                "name": "additionalInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "content"
                                  },
                                  (v36/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "status"
                              },
                              {
                                "concreteType": "AriGraphRelationshipConnection",
                                "kind": "LinkedField",
                                "name": "linkedJiraIssues",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "AriGraphRelationship",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "AriGraphRelationshipNode",
                                        "kind": "LinkedField",
                                        "name": "to",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": false,
                                            "selections": [
                                              (v19/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "idsOrAliases",
                                                        "value": [
                                                          "summary",
                                                          "assignee",
                                                          "status",
                                                          "issuetype"
                                                        ]
                                                      }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "fieldsByIdOrAlias",
                                                    "plural": true,
                                                    "selections": [
                                                      (v19/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                              (v18/*: any*/),
                                                              (v17/*: any*/),
                                                              {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v37/*: any*/),
                                                                  (v17/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraStatusField"
                                                      },
                                                      (v17/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "fieldId"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "text"
                                                          }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                              (v19/*: any*/),
                                                              (v18/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "picture"
                                                              },
                                                              (v17/*: any*/)
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                      },
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              (v18/*: any*/),
                                                              {
                                                                "concreteType": "JiraAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "small"
                                                                  }
                                                                ]
                                                              },
                                                              (v17/*: any*/)
                                                            ]
                                                          }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                      }
                                                    ],
                                                    "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "issueId"
                                                  },
                                                  (v37/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                  }
                                                ],
                                                "type": "JiraIssue"
                                              },
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/),
                                              (v26/*: any*/),
                                              (v27/*: any*/),
                                              (v28/*: any*/),
                                              (v29/*: any*/),
                                              (v30/*: any*/),
                                              (v31/*: any*/),
                                              (v32/*: any*/),
                                              (v33/*: any*/),
                                              (v34/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v14/*: any*/)
                                ]
                              },
                              (v17/*: any*/),
                              (v36/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "introducedDate"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "providerVulnerabilityId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "securityContainerId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "severity"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "description"
                              }
                            ]
                          },
                          (v17/*: any*/),
                          (v19/*: any*/)
                        ]
                      },
                      (v38/*: any*/)
                    ]
                  },
                  (v39/*: any*/)
                ]
              },
              {
                "args": (v35/*: any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "security__linkedSecurityVulnerabilitiesByProject",
                "kind": "LinkedHandle",
                "name": "linkedSecurityVulnerabilitiesByProject"
              },
              {
                "alias": "projectHaveVulnerabilityCheck",
                "concreteType": "GraphJiraVulnerabilityConnection",
                "kind": "LinkedField",
                "name": "linkedSecurityVulnerabilitiesByProject",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphJiraVulnerabilityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GraphJiraVulnerability",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                            "kind": "LinkedField",
                            "name": "vulnerability",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v17/*: any*/)
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "linkedVulnsForAnalytics",
                "args": (v16/*: any*/),
                "concreteType": "GraphJiraVulnerabilityConnection",
                "kind": "LinkedField",
                "name": "linkedSecurityVulnerabilitiesByProject",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphJiraVulnerabilityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "GraphJiraVulnerability",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "condition": "getContainers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                "kind": "LinkedField",
                                "name": "vulnerability",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "ThirdPartySecurityContainer",
                                    "kind": "LinkedField",
                                    "name": "securityContainer",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v17/*: any*/)
                                    ]
                                  },
                                  (v17/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "getContainers",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v10/*: any*/),
                    "concreteType": "AriGraphRelationshipConnection",
                    "kind": "LinkedField",
                    "name": "linkedSecurityContainers",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationshipEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationship",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "AriGraphRelationshipNode",
                                "kind": "LinkedField",
                                "name": "to",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "data",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "icon"
                                          },
                                          (v36/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "providerName"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "lastUpdated"
                                          },
                                          (v14/*: any*/),
                                          (v17/*: any*/)
                                        ],
                                        "type": "ThirdPartySecurityContainer"
                                      },
                                      (v22/*: any*/),
                                      (v23/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/),
                                      (v34/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v19/*: any*/)
                            ]
                          },
                          (v38/*: any*/)
                        ]
                      },
                      (v39/*: any*/)
                    ]
                  },
                  {
                    "args": (v10/*: any*/),
                    "handle": "connection",
                    "key": "security__linkedSecurityContainers",
                    "kind": "LinkedHandle",
                    "name": "linkedSecurityContainers"
                  }
                ]
              }
            ]
          }
        ]
      },
      (v20/*: any*/)
    ]
  },
  "params": {
    "id": "0376bc7752cbb270206d5bcd51b533ec3fa2f679207bdd786d4dab220eace86f",
    "metadata": {},
    "name": "SecurityPageRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e4de580b4abe10bed553ada356d774cf";

export default node;
